import "./PaymentMethodSelector.css"

const METHODS = {
  card: {
    title: "Cartão de crédito",
    subtitle: "Cobrança automática no cartão a cada renovação",
  },
  pix: {
    title: "Pix",
    // Pix Automático may be off in production: no "débito automático" here (D67).
    subtitle: "Aprovação na hora",
  },
}

// Order of the rows; card first and preselected (D67).
export const PAYMENT_METHODS = ["card", "pix"]

/**
 * Payment method rows inside the selected plan card on /plan (spec asaas-pix
 * D67): only the methods the api returns; nothing to choose when card is the
 * only one (PT/OTHER tax ids, Pix off), so no rows then.
 */
export default function PaymentMethodSelector({ methods, selected, onSelect }) {
  const available = PAYMENT_METHODS.filter((method) => methods.includes(method))
  if (available.length < 2) return null

  return (
    <div className="paymentMethod" role="radiogroup" aria-label="Forma de pagamento">
      {available.map((method) => {
        const isSelected = selected === method
        return (
          <button
            key={method}
            type="button"
            role="radio"
            aria-checked={isSelected}
            className={`paymentMethod__option${isSelected ? " paymentMethod__option--selected" : ""}`}
            onClick={(e) => {
              // The row lives inside the clickable plan card.
              e.stopPropagation()
              onSelect(method)
            }}
          >
            <span className="paymentMethod__radio" aria-hidden="true" />
            <span className="paymentMethod__body">
              <span className="paymentMethod__title">{METHODS[method].title}</span>
              <span className="paymentMethod__subtitle">{METHODS[method].subtitle}</span>
            </span>
          </button>
        )
      })}
    </div>
  )
}
